import { storageFactory } from 'storage-factory';

const storage = storageFactory(() => localStorage);

const LocalStoragePort = {
  getItem: storage.getItem,
  add: (app) => {
    app.ports.setItem.subscribe((object) => {
      storage.setItem(object.key, object.value)
    });

    app.ports.getItemPort.subscribe(function(object) {
      const value = storage.getItem(object.key);

      app.ports.gotItemPort.send({ value: value, itemType: object.itemType });
    });

    app.ports.removeItem.subscribe((key) => (storage.removeItem(key)));
  }
}

module.exports = LocalStoragePort;
